/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee7129996bcdd9cb958d21a3e9c19719>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/quotation-mark';
import NewObjectComponent from '@atlaskit/object/tile/blog';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/blog/24';

/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Blog24Icon = function Blog24Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  // Feature flag to migrate to new object package
  if (fg('platform_dst_icon_object_to_object')) {
    // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/React.createElement(NewObjectComponent, {
      label: label,
      testId: testId,
      size: "small"
    });
  }
  return /*#__PURE__*/React.createElement(IconTile, {
    icon: NewIcon,
    appearance: "blueBold",
    size: "24",
    label: label,
    testId: testId,
    LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    })
  });
};
Blog24Icon.displayName = 'Blog24Icon';
export default Blog24Icon;